import {GetSolusPortal} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetSolusPortal} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetSolusPortalUrl = (): GetSolusPortal =>
	new RemoteGetSolusPortal(
		makeBFFApiUrl(ExternalLinkPoint.solusPortal),
		makeAuthorizeHttpClientDecorator(),
	);
